export default __webpack_public_path__ + "static/media/the-muskateers-vs-cthulu.b5ad390d.jpg";